var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{staticStyle:{"width":"100%"},attrs:{"id":_vm.name}}):_c('empty',{attrs:{"name":"暂无数据","height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }